import { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { Loader, Text } from '../common';

const API_EPISODES_URL = 'https://rickandmortyapi.com/api/episode';

export function PopupEpisodes({ episodes }) {
  const [series, setSeries] = useState([]);
  const [isFetching, setIsFetching] = useState(true);

  useEffect(() => {
    if (!episodes?.length) {
      setIsFetching(false);

      return;
    }

    setIsFetching(true);
    setSeries([]);

    const episodesIds = episodes.map((ep) => ep.match(/\d+$/)[0]);

    fetch(`${API_EPISODES_URL}/${episodesIds.join(',')}`)
      .then((res) => res.json())
      .then((data) => {
        setSeries(episodes.length === 1 ? [data] : data);
        setIsFetching(false);
      })
      .catch(() => {
        setIsFetching(false);
      });
  }, [episodes]);

  if (isFetching) {
    return <Loader />;
  }

  return (
    <PopupEpisodesContainer>
      <Text>Participated in episodes:</Text>

      <StyledPopupEpisodes $length={series.length}>
        {series.map(({ id, name, episode }) => (
          <Episode key={id}>
            <EpisodeMarking>
              {episode
                .replace(/S0?(\d+)/, 'Season $1 - ')
                .replace(/E0?(\d+)/, 'Ep. $1')}
            </EpisodeMarking>
            {name}
          </Episode>
        ))}
      </StyledPopupEpisodes>
    </PopupEpisodesContainer>
  );
}

const PopupEpisodesContainer = styled.div``;

const StyledPopupEpisodes = styled.div`
  display: flex;
  flex-direction: column;

  ${({ $length }) =>
    $length > 20 &&
    css`
      display: grid;
      grid-auto-flow: column;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: repeat(${Math.ceil($length / 2)}, 1fr);

      & p {
        width: 95%;
        border-bottom: 2px solid #eee;
      }

      @media (max-width: 600px) {
        grid-template-columns: 1fr;

        & span {
          margin-bottom: 10px;
        }
      }
    `}
`;

const Episode = styled.p`
  width: 100%;
  display: grid;
  align-items: center;
  padding: 10px 0;
`;

const EpisodeMarking = styled.span`
  margin-bottom: 8px;
  color: #83bf46;
`;
